import { PageUrlMappings } from '../PageUrlMappings';
export const pageFromUrl = url => {
  for (const pageKey in PageUrlMappings) {
    if (url && url.search(PageUrlMappings[pageKey].path) > -1) {
      return PageUrlMappings[pageKey];
    }
  }
  return undefined;
};